import { ApiGpdGpdsListRequest, GPD } from "@nens/brostar/openapi-client";
import { qualityRegimeOptionsType } from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const gpdInformation: SearchOption<keyof GPD, keyof ApiGpdGpdsListRequest>[] = [
  { key: "broId", searchKey: "broIdIcontains", label: "BRO-ID" },
  { key: "internalId", label: "Interne naam" },
  { key: "startTime", label: "Starttijd" },
  { key: "endTime", label: "Eindtijd" },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((option) => ({ key: option, label: option })),
  },
];
